import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' })
//   'application/x-www-form-urlencoded; charset=UTF-8'
};

@Injectable()
export class PersonService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  getPersonSearch(param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/person_all',param, this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('person_all', []))
      );
  }
  getProgress (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/person/progress_all/' + param.eid + '/'+ param.page + '/'  + param.display_per_page, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('progress_all', []))
      );
  }
  getImportHistory(eid){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/person/import_history_list/' + eid, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('import_history_list', []))
      );
  }

  getProgressSearch(param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/progress_all',param, this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('progress_all', []))
      );
  }

  save (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('save', []))
      );
  }
  delete (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('delete', []))
      );
  }
  delpersons (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/delete_csv',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('delete_csv', []))
      );
  }
  importPerson(file_data:any){
//    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/file/import_person',file_data)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('import_person', []))
      );
  }
  pw_reset(param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('pw_reset', []))
      );
  }
  getHistory(id:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/person/userhistory_by_id/' +id, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('userhistory_by_id', []))
      );
  }
  // createCsv(params:any){
  //   this.commonService.loadingStart();
  //   this.http.post(environment.apiUrl+'/api/person/csv_outdata',params,httpOptions)
  //     .pipe(
  //       tap(Response => this.commonService.loadingEnd()),
  //       catchError(this.commonService.handleError('saveEvent', []))
  //     );
  // }
  csvCheck(param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/person/csv_check',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('csvCheck', []))
      );
  }
  createCsvForGet(params:any){
    this.commonService.get_file(environment.apiUrl+'/api/person/csv_outdata',params);
  }
  createMendanCsvForGet(params:any){
    this.commonService.get_file(environment.apiUrl+'/api/person/csv_mendan_outdata',params);
  }
  importCheck(){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/person/check_import_person', this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('importCheck', []))
      );
  }
  getPersonYoyaku(param: any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/person/person_yoyaku/'  + param.t_person_id + '/' + param.t_yoyakuhyo_id + '/' + param.m_language_id, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('importCheck', []))
      );
  }

  getPersonpastHistoryReference(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/person/person_past_history_reference",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(
          this.commonService.handleError("person_past_history_reference", [])
        )
      );
  }
  postTeamsUrl(t_yoyaku_id){
    let param ={
      't_yoyaku_id' :t_yoyaku_id
    }
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl + "/api/person/teamsurl",param, this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('getTeamsUrl', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/person.service.ts